exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-register.error {\n  color: #ff0000;\n}\n.user-register.warning {\n  color: #ff7e05;\n}\n.user-register.success {\n  color: #52c41a;\n}\n.user-layout-register .ant-input-group-addon:first-child {\n  background-color: #fff;\n}\n", ""]);

// exports
